/* eslint-disable */
import {isCmsPath} from '@shared/_helpers'
import UserApi from '@shared/_api/user';
import {FETCH_CONFERENCE_LIST_SUCCESS, FETCH_CURRENT_USER_SUCCESS} from "./mutation-types";
import VueCookies from "vue-cookies";
import ConferenceApi from "../_api/conference";
import * as _ from "lodash";

const state = {
    user: null,
    showLoginFailAlert: false,
    loadingUser: false,
    conferenceList: [],
    apiError: null
};

const getters = {
    hasRole(state) {
        return role => state.user && state.user.roles.some(r => r.name === role);
    },
    canRead(state) {
        return resource => state.user && state.user.authorities.some(a => {
            return a.authority === resource + 'READ' || a.authority === resource + 'WRITE';
        } );
    },
    canWrite(state) {
        return resource => state.user && state.user.authorities.some(a => {
            return a.authority === resource + 'WRITE';
        } );
    },
    nextConference(state) {
        let conferenceList = state.conferenceList,
            now = new Date();

        if (conferenceList && conferenceList.length > 0) {

            _.sortBy(conferenceList, ['validFromDate']).reverse();

            return conferenceList[0];
        }

        return null;
    },
    activeConference: (state, getters) => {
        if (getters['nextConference']) {
            let nextConference = getters['nextConference'],
                validFrom = new Date(nextConference.validFromDate),
                validTo = new Date(nextConference.validToDate),
                now = new Date();

            validFrom.setMinutes(validFrom.getMinutes() - 5);
            if (now > validFrom && now < validTo) {
                return nextConference;
            }
        }
    }

};

const actions = {
    login({commit, dispatch}, {username, password}) {
        commit('loginRequest', {username});

        return UserApi.authUser(username, password).then(tokenData => {
            let expireDate = new Date(new Date().getTime() + (1000 * tokenData.expires_in)),
                authDetails = {
                    username: username,
                    token: tokenData.access_token,
                    email: username
                };

            $cookies.set('user', authDetails, expireDate);

            commit('loginSuccess', tokenData);

            window.$cookies.remove('hideSamplePopup');

            return dispatch('refreshSessionData');

        }).catch(error => {
            console.log(error);
            commit('loginFailure', error);

            return Promise.reject();
        });
    },
    logout({commit}) {
        return UserApi.logout().finally(() => {
            commit('logout');
            return Promise.resolve();
        });
    },
    refreshSessionData({commit, rootState}) {
        if (!VueCookies.isKey('sessionId')) {
            var expireDate = new Date(new Date().getTime() + (1000 * 7 * 24 * 60 * 60));
            VueCookies.set('sessionId', '_' + Math.random().toString(36).substr(2, 9), expireDate);
        }

        const loggedIn = VueCookies.isKey('user');
        if (loggedIn && !rootState.account.user) {
            return UserApi.fetchCurrentUser().then(user => {
                commit(FETCH_CURRENT_USER_SUCCESS, user);
                return user;
            })
        } else if (loggedIn) {
            return Promise.resolve(rootState.account.user)
        } else {
            return Promise.resolve(null);
        }
    },
    fetchConferenceList({commit, rootState}) {
        return ConferenceApi.byCurrentUser().then((conferenceList) => {
            commit(FETCH_CONFERENCE_LIST_SUCCESS, conferenceList);
        })
    },
    updateUserProfile({commit}, {user}) {
        // TODO
    },
    hideLoginFailAlert({commit}) {
        commit('hideLoginFailAlert');
    }
};

const mutations = {
    [FETCH_CURRENT_USER_SUCCESS](state, user) {
        state.user = user;
    },
    [FETCH_CONFERENCE_LIST_SUCCESS](state, conferenceList) {
        state.conferenceList = conferenceList;
    },
    loginRequest(state, user) {
        state.loadingUser = true;
        state.apiError = null;
    },
    loginSuccess(state, tokenData) {
        state.showLoginFailAlert = false;
        state.loadingUser = false;
    },
    loginFailure(state) {
        state.user = null;
        state.showLoginFailAlert = true;
        state.loadingUser = false;
        state.apiError = "Wrong credentials or account not activated.";
    },
    hideLoginFailAlert(state) {
        state.showLoginFailAlert = false;
    },
    logout(state) {
        $cookies.remove('user');
        state.user = null;
    }
};

export const account = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};